import React from "react";

const FeedbackStepLayout = ({
  title,
  subtitle,
  step,
  totalSteps,
  children,
  onNext,
  onBack,
  onClose,
  isLast = false,
}) => {
  const showProgress = !isLast;
  const filledBars = Array.from({ length: totalSteps }, (_, i) => i < step);

  return (
    <div className="relative w-full h-full flex flex-col justify-between">
      {/* === Top Section === */}
      <div>
        {/* === Header === */}
        <div className="text-black text-xl font-bold font-['Inter'] mb-4">
          {title}
        </div>

        {/* === Progress Bar (hidden on final screen) === */}
        {showProgress && (
          <div className="flex gap-2 mb-6">
            {filledBars.map((filled, i) => (
              <div
                key={i}
                className={`w-14 h-1 rounded-[10px] transition-colors ${
                  filled ? "bg-black" : "bg-zinc-300"
                }`}
              />
            ))}
          </div>
        )}

        {/* === Subtitle === */}
        {subtitle && (
          <div className="text-black text-xs font-bold font-['Inter'] mb-4">
            {subtitle}
          </div>
        )}

        {/* === Step Content (Mechanism) === */}
        <div className="mb-24">{children}</div>
      </div>

      {/* === Fixed Buttons (Bottom Right Corner) === */}
      <div className="absolute bottom-4 right-4 flex items-center gap-3">
        {step > 1 && (
          <button
            onClick={onBack}
            className="w-24 h-7 bg-white text-black border border-black 
                       rounded-[5px] text-sm font-medium hover:bg-gray-100 transition"
          >
            Previous
          </button>
        )}
        <button
          onClick={isLast ? onClose : onNext}
          className="w-24 h-7 bg-black text-white rounded-[5px] 
                     text-sm font-medium hover:bg-neutral-800 transition"
        >
          {isLast ? "Finish" : "Next"}
        </button>
      </div>
    </div>
  );
};

export default FeedbackStepLayout;
